<div class="flex flex-col gap-4 h-full">
  <!-- Toolbar -->
  <div class="flex flex-wrap items-center justify-between gap-4 bg-primary-container rounded-lg p-4 border border-outline/20">
    <div>
      <h3 class="text-title-medium text-on-surface">現場配置図の管理</h3>
      <p class="text-body-medium text-on-surface-variant">
        @if (drawingUrl()) {
          図面上のセンサーをドラッグ＆ドロップして配置位置を調整できます。
        } @else {
          現場の図面画像をアップロードしてください。
        }
      </p>
    </div>
    
    <div class="flex items-center gap-2">
      <input type="file" #fileInput class="hidden" accept="image/png, image/jpeg, image/webp" (change)="onFileSelected($event)">
      
      @if (drawingUrl()) {
        <button matButton class="text-error" [disabled]="isUploading() || isSaving()" (click)="deleteDrawing()">
          <mat-icon>delete</mat-icon>
          図面削除
        </button>
      }
      
      <button matButton (click)="fileInput.click()" [disabled]="isUploading()">
        <mat-icon>upload</mat-icon>
        画像アップロード
      </button>

      <button matTonalButton [disabled]="!hasChanges() || isSaving()" (click)="saveChanges()">
        <mat-icon>save</mat-icon>
        変更を保存
      </button>
    </div>
  </div>

  @if (isUploading()) {
    <div class="bg-primary-container p-4 rounded-lg">
      <p class="text-label-medium mb-2">アップロード中... {{ uploadProgress() }}%</p>
      <mat-progress-bar mode="determinate" [value]="uploadProgress()"></mat-progress-bar>
    </div>
  }

  <section class="flex flex-wrap items-center justify-between gap-4 bg-primary-container rounded-lg p-4 border border-outline/20">
    <div>
      <h3 class="text-title-small text-on-surface">北方位</h3>
      <p class="text-body-small text-on-surface-variant">図面上の北の向きを設定します。</p>
    </div>

    <div class="flex flex-wrap items-center gap-5">
      <div
        #northCompass
        class="relative grid size-44 touch-none place-items-center rounded-full bg-surface shadow-[0_0_0_10px_rgba(0,0,0,0.10)] cursor-grab"
        role="slider"
        tabindex="0"
        aria-label="北方位"
        aria-valuemin="0"
        aria-valuemax="359"
        [attr.aria-valuenow]="northAngle()"
        (pointerdown)="startNorthAngleDrag($event, northCompass)"
        (pointermove)="continueNorthAngleDrag($event, northCompass)"
        (pointerup)="stopNorthAngleDrag($event, northCompass)"
        (pointercancel)="stopNorthAngleDrag($event, northCompass)"
        (keydown)="onNorthAngleKeydown($event)"
      >
        <div class="absolute inset-0 rounded-full border-2 border-on-surface/80"></div>
        <div
          data-testid="north-angle-dial"
          class="absolute inset-3 rounded-full transition-transform duration-150 ease-out"
          [style.transform]="'rotate(' + northAngle() + 'deg)'"
        >
          @for (tick of compassTicks; track tick) {
            <span
              class="absolute left-1/2 top-1/2 block h-5 w-px origin-[50%_0] bg-on-surface/70"
              [class.h-7]="tick % 90 === 0"
              [class.w-0.5]="tick % 90 === 0"
              [style.transform]="'rotate(' + tick + 'deg) translateY(-4.75rem)'"
            ></span>
          }
          <span class="absolute left-1/2 top-1 -translate-x-1/2 text-3xl font-black leading-none text-on-surface">N</span>
          <span class="absolute right-1 top-1/2 -translate-y-1/2 text-3xl font-black leading-none text-on-surface">E</span>
          <span class="absolute bottom-1 left-1/2 -translate-x-1/2 text-3xl font-black leading-none text-on-surface">S</span>
          <span class="absolute left-1 top-1/2 -translate-y-1/2 text-3xl font-black leading-none text-on-surface">W</span>
        </div>
        <div class="pointer-events-none absolute inset-0 rounded-full border border-outline/30"></div>
      </div>

      <label class="flex items-center gap-2 text-body-medium text-on-surface">
        <span>角度</span>
        <input
          class="w-24 rounded border border-outline/30 bg-surface px-3 py-2 text-right text-on-surface"
          type="number"
          min="0"
          max="359"
          step="1"
          [value]="northAngle()"
          (input)="onNorthAngleInput($event)"
        >
        <span>°</span>
      </label>

      <button matTonalButton [disabled]="!hasNorthAngleChanged() || isSaving()" (click)="saveNorthAngle()">
        <mat-icon>explore</mat-icon>
        北方位を保存
      </button>
    </div>
  </section>

  <!-- Canvas -->
  <div class="grow min-h-0 relative">
    @if (isLoading()) {
      <div class="absolute inset-0 z-50 flex items-center justify-center bg-surface/50 backdrop-blur-sm rounded-lg">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }
    
    <app-site-drawing-canvas
      [drawingUrl]="drawingUrl()"
      [sensors]="siteSensors()"
      (positionChanged)="onPositionChanged($event)"
    ></app-site-drawing-canvas>
  </div>
</div>
